import { render, staticRenderFns } from "./Accordions.vue?vue&type=template&id=7fb704de&scoped=true&"
import script from "./Accordions.vue?vue&type=script&lang=js&"
export * from "./Accordions.vue?vue&type=script&lang=js&"
import style0 from "./Accordions.vue?vue&type=style&index=0&id=7fb704de&lang=scss&scoped=true&"
import style1 from "./Accordions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb704de",
  null
  
)

export default component.exports